<template>
    <select>
        <option selected="selected" disabled>SELECT TRANSPORT</option>
        <option v-for="(transport, index) in this.transportTypes" v-bind:key="index" :value="index">{{transport.name}}</option>
    </select>
</template>

<script>

import transportJson from '../assets/data/transportModes.json';

export default {
  name: 'TranportDropdown',
  data() {
      return {
          transportTypes: transportJson
      }
  }
}
</script>